<template>
	<p v-if="block.text" class="banners__description-text">
		{{ $rt(block.text) }}
	</p>
</template>

<script setup lang="ts">
	const props = defineProps<{
		block: {
			text?: string
		}
	}>()

	const block = computed(() => ({
		text: props.block.text,
	}))
</script>
